import * as React from 'react';

const facebookIconDark = (
    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M23.2129 11.8977C23.2129 5.75304 18.2319 0.772095 12.0872 0.772095C5.94255 0.772095 0.961609 5.75304 0.961609 11.8977C0.961609 17.4505 5.03025 22.0532 10.3494 22.8876V15.1141H7.52351V11.8977H10.3494V9.44675C10.3494 6.65867 12.0094 5.11888 14.5516 5.11888C15.7687 5.11888 17.0415 5.33583 17.0415 5.33583V8.07273H15.6397C14.2567 8.07273 13.8262 8.93052 13.8262 9.81056V11.8977H16.9113L16.4184 15.113H13.8262V22.8876C19.1442 22.0532 23.2129 17.4505 23.2129 11.8977Z" fill="#073572"/>
    </svg>

);

export default facebookIconDark;
